import { CommonModule } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ToastModule } from 'ng2-toastr';
import { CalendarModule } from 'primeng/calendar';
import { AccordionModule, EditorModule, LightboxModule } from 'primeng/primeng';
import { IssueWebCreatePublicComponent } from '../app/components/IssueWeb/public/issue-web-create-public/issue-web-create-public.component';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ForgotCredentialsComponentComponent } from './components';
import { IncidentAccidentDetailsPublicComponent } from './components/incident-accident/public/incident-accident-details-public.component';
import { IncidentAccidentPublicComponent } from './components/incident-accident/public/incident-accident-public.component';
import { IssueWebConfirmationComponent } from './components/IssueWeb/public/issue-web-confirmation/issue-web-confirmation.component';
import { UpdateInfoComponent } from './components/tenants/public/update-info.component';
import { DataService, UtilityService } from './core/services';
import { SafePipe } from './issue-web/component/issue-action/issue-action.component';
import { LoansConfirmComponent } from './loans/components/loans-confirm/loans-confirm.component';
import { CalendarService, AccountService, AuthenticationService, CommonService, IncidentAccidentServiceService, IssueType1Service, IssueType2Service, IssueType3Service, IssueWebService, LoanService, ManagerService, ModuleService, SettingsService, SiteService, TenantService } from './services';
import { AuthGuard } from './shared';
import { GlobalErrorHandler } from './shared/errorhandler/GlobalErrorHandler';
import { IssueGuard } from './shared/guard/issue.guard';
import { SharedModule } from './shared/shared.module';
import { FileHelperService } from './services/file-helper.service';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';

// AoT requires an exported function for factories
export function createTranslateLoader(http: HttpClient) {
    // for development
    // return new TranslateHttpLoader(http, '/start-angular/SB-Admin-BS4-Angular-5/master/dist/assets/i18n/', '.json');
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
    imports: [
        CommonModule,
        HttpModule,
        BrowserModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,
        HttpClientModule,
        ToastModule.forRoot(),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient]
            }
        }),
        AppRoutingModule,
        FormsModule,
        CalendarModule,
        NgbModule,
        NgbModule.forRoot(),
        AccordionModule,
        LightboxModule,
        SharedModule,
        EditorModule
    ],
    declarations: [
        AppComponent,
        LoansConfirmComponent,
        ForgotCredentialsComponentComponent,
        IssueWebCreatePublicComponent,
        IncidentAccidentPublicComponent,
        IncidentAccidentDetailsPublicComponent,
        SafePipe,
        IssueWebConfirmationComponent,
        UpdateInfoComponent,
        ResetPasswordComponent,
    ],
    providers: [
        {
            provide: ErrorHandler,
            useClass: GlobalErrorHandler
        },
        AuthGuard,
        IssueGuard,
        DataService,
        UtilityService,
        AuthenticationService,
        AccountService,
        LoanService,
        IssueWebService,
        IssueType3Service,
        IssueType1Service,
        IssueType2Service,
        SettingsService,
        TenantService,
        SiteService,
        IncidentAccidentServiceService,
        ModuleService,
        ManagerService,
        CommonService,
        CalendarService,
        FileHelperService
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts